function isAppleDevice() {
  return /iPad|iPhone|iPod|Mac/.test(window.navigator.userAgent);
}

export function navigateToExternalUri(uri) {
  const anchor = document.createElement('a');
  anchor.href = uri;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export function openPhoneDialer(phone) {
  if (!phone) return;
  navigateToExternalUri(`tel:${phone}`);
}

export function buildSmsHref(phone, text) {
  const separator = isAppleDevice() ? '&' : '?';
  return `sms:${phone || ''}${separator}body=${encodeURIComponent(text)}`;
}

export function openSmsComposer(phone, text) {
  navigateToExternalUri(buildSmsHref(phone, text));
}

export function openEmailComposer(subject, text) {
  navigateToExternalUri(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`);
}

export function openWhatsAppShare(text) {
  navigateToExternalUri(`https://wa.me/?text=${encodeURIComponent(text)}`);
}

export function openMessengerShare(url, text) {
  const payloadUrl = encodeURIComponent(url || window.location.href);
  const payloadText = encodeURIComponent(text || '');
  navigateToExternalUri(`fb-messenger://share/?link=${payloadUrl}&app_id=0&text=${payloadText}`);
}

export async function openNativeShare({ title, text, url }) {
  if (!navigator.share) {
    return false;
  }

  await navigator.share({ title, text, url });
  return true;
}
